module.exports = __webpack_public_path__ + "a288c2c269d9bce1181d3e64df981b06.jpg";